export default "__VITE_ASSET__mYGbyfb0__"